if (!customElements.get('ellexa-pick-bundle')) {
  class EllexaPickBundle extends HTMLElement {
    connectedCallback() {
      this.minQty = Math.max(1, parseInt(this.dataset.minQuantity || '3', 10));
      this.discountCode = (this.dataset.discountCode || '').trim();
      this.discountPercentage = Math.max(0, Math.min(100, parseFloat(this.dataset.discountPercentage || '0') || 0));
      this.bulkEnabled = this.dataset.enableSecondDiscount === 'true';
      this.bulkDiscountCode = (this.dataset.bulkDiscountCode || '').trim();
      this.bulkDiscountPercentage = Math.max(
        0,
        Math.min(100, parseFloat(this.dataset.bulkDiscountPercentage || '0') || 0)
      );
      this.bulkMinQty = Math.max(1, parseInt(this.dataset.bulkMinQuantity || '1', 10));
      this.selected = new Map();
      this.moneyFormat =
        this.dataset.moneyFormat ||
        (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.moneyFormat) ||
        (window.themeVariables && themeVariables.settings && themeVariables.settings.moneyFormat) ||
        '€{{amount}}';

      this.labels = {
        add: this.dataset.labelAdd || 'Add to bundle',
        added: this.dataset.labelAdded || 'Added',
        hintHtml: this.dataset.labelHintHtml || 'Choose <span data-pick-remaining>__COUNT__</span> more to activate the discount',
        discountApplied: this.dataset.labelDiscountApplied || '__PERCENT__% discount applied',
        ctaAddMore: this.dataset.labelCtaAddMore || 'Add more products',
        ctaAdd: this.dataset.labelCtaAdd || 'Add',
        remove: this.dataset.labelRemove || 'Remove',
      };

      this.slotsEl = this.querySelector('[data-pick-slots]');
      this.countEl = this.querySelector('[data-pick-count]');
      this.remainingEl = this.querySelector('[data-pick-remaining]');
      this.progressEl = this.querySelector('[data-pick-progress]');
      this.totalEl = this.querySelector('[data-pick-total]');
      this.totalCompareEl = this.querySelector('[data-pick-total-compare]');
      this.hintEl = this.querySelector('[data-pick-hint]');
      this.cta = this.querySelector('[data-pick-cta]');
      this.ctaLabel = this.querySelector('[data-pick-cta-label]');

      this.onToggleClick = this.onToggleClick.bind(this);
      this.onVariantClick = this.onVariantClick.bind(this);
      this.onCtaClick = this.onCtaClick.bind(this);

      this.querySelectorAll('[data-pick-toggle]').forEach((btn) => {
        btn.addEventListener('click', this.onToggleClick);
      });
      this.querySelectorAll('[data-pick-variant]').forEach((btn) => {
        btn.addEventListener('click', this.onVariantClick);
      });
      if (this.cta) this.cta.addEventListener('click', this.onCtaClick);

      this.render();
    }

    disconnectedCallback() {
      this.querySelectorAll('[data-pick-toggle]').forEach((btn) => {
        btn.removeEventListener('click', this.onToggleClick);
      });
      this.querySelectorAll('[data-pick-variant]').forEach((btn) => {
        btn.removeEventListener('click', this.onVariantClick);
      });
      if (this.cta) this.cta.removeEventListener('click', this.onCtaClick);
    }

    getCardFromEvent(event) {
      return event.currentTarget.closest('[data-pick-product]');
    }

    getCardItem(card) {
      const variantTitle = card.dataset.variantTitle || '';
      const showVariant = variantTitle && variantTitle !== 'Default Title';

      return {
        productId: String(card.dataset.productId),
        variantId: String(card.dataset.variantId),
        title: card.dataset.productTitle || '',
        variantTitle: showVariant ? variantTitle : '',
        price: parseInt(card.dataset.productPrice || '0', 10),
        image: card.dataset.productImage || '',
        url: card.dataset.productUrl || '',
        bulk: card.dataset.pickBulk === 'true',
      };
    }

    setCardSelectedState(card, selected) {
      const toggleLabel = card.querySelector('[data-pick-toggle-label]');
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (toggleLabel) toggleLabel.textContent = selected ? this.labels.added : this.labels.add;
    }

    applyVariantToCard(card, pill) {
      const variantId = String(pill.dataset.variantId || '');
      const available = pill.dataset.variantAvailable === 'true';
      const price = parseInt(pill.dataset.variantPrice || '0', 10);
      const image = pill.dataset.variantImage || '';
      const variantTitle = pill.dataset.variantTitle || '';

      card.dataset.variantId = variantId;
      card.dataset.variantTitle = variantTitle;
      card.dataset.productPrice = String(price);
      card.dataset.available = available ? 'true' : 'false';
      card.dataset.pickBulk = pill.dataset.pickBulk === 'true' ? 'true' : 'false';
      if (image) card.dataset.productImage = image;

      card.classList.toggle('is-unavailable', !available);

      const priceEl = card.querySelector('[data-pick-price]');
      if (priceEl) priceEl.textContent = this.formatMoney(price);

      const imageEl = card.querySelector('.ellexa-pick-bundle__card-image');
      if (imageEl && image && imageEl.tagName === 'IMG') {
        imageEl.src = image;
        imageEl.srcset = '';
      }

      const toggleBtn = card.querySelector('[data-pick-toggle]');
      if (toggleBtn) toggleBtn.disabled = !available;

      card.querySelectorAll('[data-pick-variant]').forEach((btn) => {
        const isActive = String(btn.dataset.variantId) === variantId;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      const productId = String(card.dataset.productId);
      if (this.selected.has(productId)) {
        if (available) {
          this.selected.set(productId, this.getCardItem(card));
        } else {
          this.selected.delete(productId);
          this.setCardSelectedState(card, false);
        }
      }
    }

    onVariantClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const pill = event.currentTarget;
      if (pill.disabled) return;

      const card = this.getCardFromEvent(event);
      if (!card) return;

      this.applyVariantToCard(card, pill);
      this.render();
    }

    onToggleClick(event) {
      event.preventDefault();
      const card = this.getCardFromEvent(event);
      if (!card || card.dataset.available === 'false') return;

      const productId = String(card.dataset.productId);

      if (this.selected.has(productId)) {
        this.selected.delete(productId);
        this.setCardSelectedState(card, false);
      } else {
        this.selected.set(productId, this.getCardItem(card));
        this.setCardSelectedState(card, true);
      }
      this.render();
    }

    formatMoney(cents) {
      let formatted = '';
      if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
        formatted = FoxTheme.Currency.formatMoney(cents, this.moneyFormat);
      } else if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        formatted = Shopify.formatMoney(cents, this.moneyFormat);
      } else {
        formatted = `€${(cents / 100).toFixed(2)}`;
      }

      // Ensure currency symbol is present (theme format can be amount-only).
      const plain = String(formatted).replace(/<[^>]*>/g, '').trim();
      if (plain && !/[€$£]|EUR|USD|GBP|лв|lei|RON/i.test(plain)) {
        return `€${plain}`;
      }
      return plain || formatted;
    }

    getDiscountedTotal(total, percentage) {
      if (!percentage) return total;
      return Math.round((total * (100 - percentage)) / 100);
    }

    getSelectionCounts() {
      let regularCount = 0;
      let bulkCount = 0;
      this.selected.forEach((item) => {
        if (this.bulkEnabled && item.bulk) bulkCount += 1;
        else regularCount += 1;
      });
      return { regularCount, bulkCount };
    }

    isRegularReady() {
      return this.getSelectionCounts().regularCount >= this.minQty;
    }

    isBulkReady() {
      return this.bulkEnabled && this.getSelectionCounts().bulkCount >= this.bulkMinQty;
    }

    isBundleReady() {
      return this.isRegularReady() || this.isBulkReady();
    }

    getActiveDiscount() {
      if (this.isRegularReady()) {
        return { code: this.discountCode, percentage: this.discountPercentage };
      }
      if (this.isBulkReady()) {
        return { code: this.bulkDiscountCode, percentage: this.bulkDiscountPercentage };
      }
      return { code: '', percentage: 0 };
    }

    render() {
      const { regularCount } = this.getSelectionCounts();
      const itemCount = this.selected.size;
      const regularReady = this.isRegularReady();
      const bulkReady = this.isBulkReady();
      const ready = regularReady || bulkReady;
      const remaining = ready ? 0 : Math.max(this.minQty - regularCount, 0);
      const displayCount = ready ? this.minQty : regularCount;
      const total = Array.from(this.selected.values()).reduce((sum, item) => sum + (item.price || 0), 0);
      const progress = Math.min(100, Math.round((displayCount / this.minQty) * 100));
      const activeDiscount = this.getActiveDiscount();
      const showSale = ready && activeDiscount.percentage > 0 && total > 0;
      const saleTotal = showSale ? this.getDiscountedTotal(total, activeDiscount.percentage) : total;

      if (this.countEl) this.countEl.textContent = String(displayCount);
      if (this.remainingEl) this.remainingEl.textContent = String(remaining);
      if (this.progressEl) this.progressEl.style.width = `${progress}%`;

      if (this.totalCompareEl) {
        if (showSale) {
          this.totalCompareEl.hidden = false;
          this.totalCompareEl.textContent = this.formatMoney(total);
        } else {
          this.totalCompareEl.hidden = true;
          this.totalCompareEl.textContent = '';
        }
      }
      if (this.totalEl) this.totalEl.textContent = this.formatMoney(saleTotal);

      if (this.hintEl) {
        if (ready) {
          this.hintEl.hidden = false;
          this.hintEl.classList.add('is-applied');
          this.hintEl.textContent = this.labels.discountApplied.replaceAll('__PERCENT__', String(activeDiscount.percentage));
        } else {
          this.hintEl.hidden = false;
          this.hintEl.classList.remove('is-applied');
          this.hintEl.innerHTML = this.labels.hintHtml.replaceAll('__COUNT__', String(remaining));
          this.remainingEl = this.hintEl.querySelector('[data-pick-remaining]');
        }
      }

      if (this.cta) {
        this.cta.disabled = !ready;
        if (this.ctaLabel) {
          this.ctaLabel.textContent = ready ? this.labels.ctaAdd : this.labels.ctaAddMore;
        }
      }

      this.renderSlots();
    }

    renderSlots() {
      if (!this.slotsEl) return;
      const items = Array.from(this.selected.values());

      if (!items.length) {
        this.slotsEl.innerHTML = '';
        return;
      }

      this.slotsEl.innerHTML = items
        .map(
          (item) => `
          <li class="ellexa-pick-bundle__slot is-filled">
            <span class="ellexa-pick-bundle__slot-thumb">
              ${item.image ? `<img src="${item.image}" alt="" width="56" height="56" loading="lazy">` : ''}
            </span>
            <span class="ellexa-pick-bundle__slot-meta">
              <span class="ellexa-pick-bundle__slot-title">${this.escapeHtml(item.title)}</span>
              ${
                item.variantTitle
                  ? `<span class="ellexa-pick-bundle__slot-variant">${this.escapeHtml(item.variantTitle)}</span>`
                  : ''
              }
              <span class="ellexa-pick-bundle__slot-price">${this.formatMoney(item.price)}</span>
            </span>
            <button type="button" class="ellexa-pick-bundle__slot-remove" data-remove-product="${item.productId}" aria-label="${this.escapeHtml(this.labels.remove)}">×</button>
          </li>
        `
        )
        .join('');

      this.slotsEl.querySelectorAll('[data-remove-product]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const productId = String(btn.getAttribute('data-remove-product'));
          const card = this.querySelector(`[data-pick-product][data-product-id="${productId}"]`);
          if (card) this.setCardSelectedState(card, false);
          this.selected.delete(productId);
          this.render();
        });
      });
    }

    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    getExistingDiscountCodes() {
      const codes = [];
      document.querySelectorAll('.cart__discount[data-discount-code]').forEach((el) => {
        const code = (el.dataset.discountCode || '').trim();
        if (code && !codes.includes(code)) codes.push(code);
      });
      return codes;
    }

    async applyDiscountCode() {
      const { code } = this.getActiveDiscount();
      if (!code) return;

      const routes = (window.FoxTheme && FoxTheme.routes) || {};
      const updateUrl = routes.cart_update_url || '/cart/update.js';
      const discounts = this.getExistingDiscountCodes();
      if (!discounts.includes(code)) {
        discounts.push(code);
      }

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      const formData = new FormData();
      formData.append('sections', sectionsToBundle);
      formData.append('sections_url', window.location.pathname);
      formData.append('discount', discounts.join(','));

      const config =
        window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
          ? FoxTheme.utils.fetchConfig('javascript')
          : {
              method: 'POST',
              headers: { Accept: 'application/json' },
            };

      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const response = await fetch(updateUrl, config);
      if (!response.ok) {
        throw new Error('Discount apply failed');
      }
    }

    async onCtaClick() {
      if (!this.isBundleReady() || this.cta.disabled) return;

      const items = Array.from(this.selected.values()).map((item) => ({
        id: Number(item.variantId),
        quantity: 1,
      }));

      this.cta.classList.add('btn--loading');
      this.cta.setAttribute('disabled', 'true');

      try {
        const routes = (window.FoxTheme && FoxTheme.routes) || {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const config =
          window.FoxTheme && FoxTheme.utils && FoxTheme.utils.fetchConfig
            ? FoxTheme.utils.fetchConfig('javascript')
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              };

        const response = await fetch(addUrl, {
          ...config,
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const err = await response.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Cart add failed');
        }

        await this.applyDiscountCode();

        document.dispatchEvent(new CustomEvent('product-ajax:added'));
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true },
          })
        );
      } catch (error) {
        console.error('[ellexa-pick-bundle]', error);
      } finally {
        this.cta.classList.remove('btn--loading');
        this.cta.removeAttribute('disabled');
        this.render();
      }
    }
  }

  customElements.define('ellexa-pick-bundle', EllexaPickBundle);
}
